var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('v-skeleton-loader',{attrs:{"height":32,"type":"text"}}),_c('v-skeleton-loader',{staticClass:"d-none d-md-flex mt-n3 w-100 gap-1",attrs:{"type":"chip@6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }